import React, { useState, useEffect, useRef } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import "./KitchenDocuments.css";

const KitchenDocuments = ({ editMode, kitchenData, updateKitchenData }) => {
  const [documentData, setDocumentData] = useState({
    liabilityInsurance: { file: null, preview: "", url: "" },
    healthCertificate: { file: null, preview: "", url: "" },
    businessLicense: { file: null, preview: "", url: "" },
  });

  const fileInputRefs = {
    liabilityInsurance: useRef(null),
    healthCertificate: useRef(null),
    businessLicense: useRef(null),
  };

  useEffect(() => {
    if (editMode && kitchenData.documents) {
      setDocumentData({
        liabilityInsurance: kitchenData.documents.liabilityInsurance || {
          file: null,
          preview: "",
          url: "",
        },
        healthCertificate: kitchenData.documents.healthCertificate || {
          file: null,
          preview: "",
          url: "",
        },
        businessLicense: kitchenData.documents.businessLicense || {
          file: null,
          preview: "",
          url: "",
        },
      });
    }
  }, [editMode, kitchenData.documents]);

  const handleFileChange = (docType, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    const updatedDoc = { file, preview: previewUrl, url: "" };
    const newDocumentData = { ...documentData, [docType]: updatedDoc };
    setDocumentData(newDocumentData);
    updateKitchenData({ documents: newDocumentData });
  };

  const handleUploadClick = (docType) => {
    fileInputRefs[docType].current.click();
  };

  const renderPreview = (docObj) => {
    if (docObj.file) {
      const isImage = docObj.file.type.startsWith("image/");
      return isImage ? (
        <img
          src={docObj.preview}
          alt="Document Preview"
          className="doc-preview-image"
        />
      ) : (
        <p className="doc-file-name">{docObj.file.name}</p>
      );
    } else if (docObj.url) {
      const isImage = docObj.url.match(/\.(jpg|jpeg|png)$/i);
      return isImage ? (
        <img
          src={docObj.url}
          alt="Existing Document"
          className="doc-preview-image"
        />
      ) : (
        <a
          href={docObj.url}
          target="_blank"
          rel="noopener noreferrer"
          className="doc-file-link"
        >
          View Document
        </a>
      );
    } else if (docObj.url) {
      const isImage = docObj.url.match(/\.(jpg|jpeg|png)$/i);
      const isPDF = docObj.url.match(/\.pdf$/i);
      return isImage ? (
        <img
          src={docObj.url}
          alt="Existing Document"
          className="doc-preview-image"
        />
      ) : (
        <a
          href={docObj.url}
          target="_blank"
          rel="noopener noreferrer"
          className="doc-file-link"
          type={isPDF ? "application/pdf" : "application/octet-stream"}
        >
          View {isPDF ? "PDF" : "Document"}
        </a>
      );
    }
    return <FaCloudUploadAlt className="upload-icon" />;
  };

  return (
    <div className="kitchen-documents">
      <h2>{editMode ? "Edit Documents" : "Upload Documents"}</h2>
      <div className="docs-container">
        {[
          { key: "liabilityInsurance", label: "Liability Insurance" },
          { key: "healthCertificate", label: "Health Certificate" },
          { key: "businessLicense", label: "Business License" },
        ].map(({ key, label }) => (
          <div
            key={key}
            className="doc-upload-box"
            onClick={() => handleUploadClick(key)}
          >
            {renderPreview(documentData[key])}
            <p className="doc-label">{label}</p>
            <input
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              ref={fileInputRefs[key]}
              onChange={(e) => handleFileChange(key, e)}
              hidden
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default KitchenDocuments;
